/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

import { html } from "lit";
interface Documentation {
  name: string,
  url: string,
  description: string
}

interface Utility {
  name: string,
  url: string
}
interface ProductDetails {
  name: string,
  description: string,
  documentations: Array<Documentation>,
  utilities: Array<Utility>
}


const nameAndDesc =(productDetails: ProductDetails)=> {
  return html`
      <div class="flex flex-col space-y-2">
          <strong>Learn about the Products</strong>
          <p>${productDetails.description}</p>
          <a>${`Find out more about ${productDetails.name}`}</a>
      </div>
  `
}

const technicalDocs = (productDetails:ProductDetails) => {
  return html`
      <div class="flex flex-col space-y-2">
        <strong>Technical Documentation</strong>
        <div class="flex flex-col space-y-4">
          ${productDetails.documentations.map(
            (doc: any) =>
              html`
                <div class="flex flex-col space-y-1">
                  <a href=${doc.url}>${doc.name}</a>
                  <p>${doc.description}</p>
                </div>
              `
          )}
        </div>
      </div>
  `
}

const utilities = (productDetails:ProductDetails) => {
  return html`
      <div class="flex flex-col space-y-2">
        <strong>Utilities</strong>
        <div class="flex flex-col space-y-4">
          ${productDetails.utilities.map(
            (doc: any) => html` <a href=${doc.url}>${doc.name}</a> `
          )}
        </div>
      </div>
  `
}

export {nameAndDesc, technicalDocs, utilities}